<script lang="ts">
  import type { Maybe, Theme } from "../types";
  import Nav from "../components/Nav.svelte";
  import DebugFooter from "../components/debug-footer.svelte";
  import NoScript from "../components/no-script.svelte";
  import OfflineBanner from "../components/offline-banner.svelte";
  import { page } from "$app/stores";

  export let showSchedule = false;
  export let showHome = false;
  export let showMap = false;
  export let theme: Maybe<Theme> = null;

  $: segment = $page.route.id;
  $: showNav = $page.data.showNav != false;
</script>

{#if !showNav}
  <style>
    :root {
      --nav-height: 0;
    }
  </style>
{/if}

{#if segment != "style-guide"}
  <div class="Footer">
    <DebugFooter />

    {#if showNav}
      <Nav {segment} {showSchedule} {showHome} {showMap} {theme} />
    {/if}

    <OfflineBanner />

    <NoScript />
  </div>
{/if}

<style>
  .Footer {
    background: var(--theme-nav-bg, black);
    bottom: 0;
    color: white;
    flex: 0 0 auto;
    left: 0;
    position: fixed;
    touch-action: none;
    user-select: none;
    width: 100%;
  }
</style>
